export const environment = {
	isProduction: true,
	// Replaced in CI with github.run_number (token shape kept for sed match).
	buildNumber: "57",
};
